<div class="master-detail-caption">Hijos</div>
<dx-data-grid
    [dataSource]="hijo"
    >
    <dxi-column
        dataField="matricula"
        caption="Matrícula">
    </dxi-column>
    <dxi-column
        dataField="nombre"
        caption="Nombre">
    </dxi-column>
    <dxi-column
        dataField="apellidopaterno"
        caption="Ap. paterno">
    </dxi-column>
    <dxi-column
        dataField="apellidomaterno"
        caption="Ap. materno">
    </dxi-column>
    <dxi-column
        dataField="nivel"
        caption="Nivel">
    </dxi-column>
    <dxi-column
        dataField="grado"
        caption="Grado">
    </dxi-column>
    <dxi-column
        dataField="grupo"
        caption="Grupo">
    </dxi-column>

    <dxi-column
        dataField="estatus"
        caption="Estatus">
    </dxi-column>
</dx-data-grid>

<div class="divisor16"></div>
<div class="master-detail-caption">Horario</div>
<dx-data-grid
    [dataSource]="horarioespecial"
    >
    <dxi-column
        dataField="ciclo"
        caption="Ciclo">
    </dxi-column>
    <dxi-column
        dataField="semestre"
        caption="Semestre">
    </dxi-column>
    <dxi-column
        dataField="lunesentrada"
        caption="LUN ent.">
    </dxi-column>
    <dxi-column
        dataField="lunessalida"
        caption="LUN sal.">
    </dxi-column>
    <dxi-column
        dataField="martesentrada"
        caption="MAR ent.">
    </dxi-column>
    <dxi-column
        dataField="martessalida"
        caption="MAR sal.">
    </dxi-column>
    <dxi-column
        dataField="miercolesentrada"
        caption="MIE ent.">
    </dxi-column>
    <dxi-column
        dataField="miercolessalida"
        caption="MIE sal.">
    </dxi-column>
    <dxi-column
        dataField="juevesentrada"
        caption="JUE ent.">
    </dxi-column>
    <dxi-column
        dataField="juevessalida"
        caption="JUE sal.">
    </dxi-column>
    <dxi-column
        dataField="viernesentrada"
        caption="VIE ent.">
    </dxi-column>
    <dxi-column
        dataField="viernessalida"
        caption="VIE sal.">
    </dxi-column>
    <dxi-column
        dataField="sabadoentrada"
        caption="SAB ent.">
    </dxi-column>
    <dxi-column
        dataField="sabadosalida"
        caption="SAB sal.">
    </dxi-column>
    <dxi-column
        dataField="domingoentrada"
        caption="DOM ent.">
    </dxi-column>
    <dxi-column
        dataField="domingosalida"
        caption="DOM sal.">
    </dxi-column>
    <dxi-column
        dataField="fecha"
        caption="Última modif."
        dataType="date"
        format="dd/MM/yyyy">
    </dxi-column>
    <dxi-column
        dataField="usuario"
        caption="Modificado por">
    </dxi-column>
</dx-data-grid>

<div class="divisor16"></div>
<div class="master-detail-caption">Horario especial</div>
<dx-data-grid
    [dataSource]="horario">

    <dxi-column
        dataField="ciclo"
        caption="Ciclo">
    </dxi-column>
    <dxi-column
        dataField="semestre"
        caption="Semestre">
    </dxi-column>
    <dxi-column
        dataField="horarioespecial"
        caption="Horario especial">
    </dxi-column>
    <dxi-column
        dataField="fecha"
        caption="Última modif."
        dataType="date"
        format="dd/MM/yyyy">
    </dxi-column>
    <dxi-column
        dataField="usuario"
        caption="Modificado por">
    </dxi-column>
</dx-data-grid>

<div class="divisor16"></div>
<div class="master-detail-caption">Estudios</div>
<dx-data-grid
    [dataSource]="estudio"
    >
    <dxi-column
        dataField="escolaridad"
        caption="Nivel de estudio">
    </dxi-column>
    <dxi-column
        dataField="titulo"
        caption="Título">
    </dxi-column>
    <dxi-column
        dataField="institucioneducativa"
        caption="Institución educativa">
    </dxi-column>
    <dxi-column
        dataField="estatus"
        caption="Estatus">
    </dxi-column>
    <dxi-column
        dataField="cedulaprofesional"
        caption="Cédula profesional">
    </dxi-column>
</dx-data-grid>

<div class="divisor16"></div>
<div class="master-detail-caption">Puestos</div>
<dx-data-grid
    [dataSource]="puesto"
    >
    <dxi-column
        dataField="puesto"
        caption="Puesto">
    </dxi-column>
    <dxi-column
        dataField="puestosuperior"
        caption="Puesto superior">
    </dxi-column>
    <dxi-column
        dataField="fechaasignado"
        caption="Fecha de asignación"
        dataType="date"
        format="dd/MM/yyyy">
    </dxi-column>
    <dxi-column
        dataField="usuarioasignado"
        caption="Asignado por">
    </dxi-column>
    <dxi-column
        dataField="antiguedad"
        caption="Antigüedad">
    </dxi-column>
</dx-data-grid>

<div class="divisor16"></div>
<div class="master-detail-caption">Historial de puestos</div>
<dx-data-grid
    [dataSource]="puestohistorial"
    >
    <dxi-column
        dataField="puesto"
        caption="Puesto">
    </dxi-column>
    <dxi-column
        dataField="puestosuperior"
        caption="Puesto superior">
    </dxi-column>
    <dxi-column
        dataField="fechaasignado"
        caption="Fecha de asignación"
        dataType="date"
        format="dd/MM/yyyy">
    </dxi-column>
    <dxi-column
        dataField="usuarioasignado"
        caption="Asignado por">
    </dxi-column>
    <dxi-column
        dataField="fechaeliminado"
        caption="Fecha de eliminado"
        dataType="date"
        format="dd/MM/yyyy">
    </dxi-column>
    <dxi-column
        dataField="usuarioeliminado"
        caption="Eliminado por">
    </dxi-column>
    <dxi-column
        dataField="antiguedad"
        caption="Antigüedad">
    </dxi-column>
</dx-data-grid>